import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

const propsSchema: PropsSchemaList = [
  {
    key: 'stylesheet',
    label: 'Style Sheet',
    type: types.OBJECT,
    children: [
      {
        key: 'inlineCssScopeId',
        label: 'Inline CSS scope Id',
        tooltip: 'The inline CSS will only be applied to all children elements under the root element',
        type: types.TEXT
      },
      {
        key: 'inlineCss',
        label: 'Inline CSS resource',
        type: types.ARRAY,
        children: [
          {
            key: 'url',
            label: 'The file includes the pure CSS content',
            tooltip: 'The file should include pure CSS content without <style></style> tags',
            type: types.S3_ASSET_URL
          }
        ]
      }
    ]
  },
  {
    key: 'javascript',
    label: 'Javascript',
    type: types.OBJECT,
    children: [
      {
        key: 'jsReference',
        label: 'Javascript references',
        type: types.ARRAY,
        children: [
          {
            key: 'url',
            label: 'Javascript resource url',
            tooltip: 'The javascript resource will be added to head section',
            type: types.TEXT
          },
          {
            key: 'isModule',
            label: 'Is module',
            tooltip: 'The javascript will be treated as a module',
            type: types.BOOLEAN,
          }
        ]
      },
      {
        key: 'inlineJs',
        label: 'Inline javascript',
        type: types.ARRAY,
        children: [
          {
            key: 'url',
            label: 'The file includes the pure javascript',
            tooltip: 'The file should only include pure javascript without <script></script> tags',
            type: types.S3_ASSET_URL
          },
          {
            key: 'isModule',
            label: 'Is module',
            tooltip: 'The javascript will be treated as a module',
            type: types.BOOLEAN,
          }
        ]
      },
    ]
  },
  {
    key: 'html',
    label: 'HTML Raw Code',
    type: types.HTML
  }
];

const defaultProps = {
  html: `
    <h1>Flexible HTML Component</h1>
    <p>
      Use this component to add custom HTML to a section and specify the JS and CSS resource urls.
    </p>
  `
};

export default {
  title: 'Flexible HTML',
  id: 'FlexibleHTML',
  propsSchema,
  defaultProps
};
